import { render } from "./VideocallRegisterPopup.vue?vue&type=template&id=a59d61e4"
import script from "./VideocallRegisterPopup.vue?vue&type=script&lang=js"
export * from "./VideocallRegisterPopup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__